import { Heading, Subheading } from "./catalyst/heading";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import Link from "next/link";

type MarkdownProps = {
  children: string;
  className?: string;
};

export function Markdown({ children, className }: MarkdownProps) {
  return (
    <div className={className}>
      <ReactMarkdown
        remarkPlugins={[remarkBreaks]}
        components={{
          h1: ({ node: _node, ...props }) => <Heading level={1} {...props} />,
          h2: ({ node: _node, ...props }) => (
            <Subheading level={2} {...props} />
          ),
          h3: ({ node: _node, ...props }) => (
            <Subheading level={3} {...props} />
          ),
          h4: ({ node: _node, ...props }) => (
            <Subheading level={4} {...props} />
          ),
          h5: ({ node: _node, ...props }) => (
            <Subheading level={5} {...props} />
          ),
          h6: ({ node: _node, ...props }) => (
            <Subheading level={6} {...props} />
          ),
          a: ({ node: _node, ...props }) => (
            <Link
              {...props}
              href={props.href ?? ""}
              className="underline decoration-purple-500/50 hover:decoration-purple-500"
              target="_blank"
              rel="noopener noreferrer"
            />
          ),
          p: ({ node: _node, ...props }) => <p className="mb-3" {...props} />,
          ul: ({ node: _node, ...props }) => (
            <ul className="list-disc pl-5 mb-3" {...props} />
          ),
          ol: ({ node: _node, ...props }) => (
            <ol className="list-decimal pl-5 mb-3" {...props} />
          ),
          li: ({ node: _node, ...props }) => <li className="mb-1" {...props} />,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
